import React from 'react';
import PropTypes from 'prop-types';
import { Button, Tooltip } from 'antd';
import './style/index.less';

const ButtonGroup = Button.Group;

function noop() {}

/**
 *  Button
 */
export default class extends React.Component {
  static Group = ButtonGroup;

  static propTypes = {
    /**
     * 是否用Tooltip组件显示提示信息
     */
    tooltip: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),
    cdmsicon: PropTypes.string,//cdms系统按钮icon
    onClick: PropTypes.func,//按钮点击事件
  };

  static defaultProps = {
    prefixCls: 'iconfont icon-',
    cdmsPrefixCls: 'cdms-btn',
    cdmsicon: '',
    onClick: noop,
  };

  render() {
    const { 
      tooltip, 
      prefixCls, 
      cdmsPrefixCls,//cdms系统定制按钮样式
      customicon, 
      size, 
      style, 
      cdmsicon,
      ...otherProps 
    } = this.props;

    let custombutton = null;

    if (cdmsicon) {

      //cdms系统定制按钮
      custombutton = <Button className={cdmsPrefixCls} size={size} style={style} {...otherProps} disabled={this.props.disabled} onClick={(event) => {this.props.onClick && this.props.onClick(event)}}>
          <i className={prefixCls + cdmsicon} style={style}></i>
          <span>{this.props.children}</span>
        </Button>
    } else {
      custombutton = customicon ? (
        <Button size={size} style={style} {...otherProps}>
          <i className={prefixCls + customicon} style={style}>
          </i>
          <span>{this.props.children}</span>
        </Button>
      ) : (
        <Button size={size} style={style} {...otherProps}/>
      );
    }
    
    
    return tooltip ? (
      <Tooltip overlayClassName={prefixCls} title={tooltip === true ? otherProps.title : tooltip}>
        {custombutton}
      </Tooltip>
    ) : (
      <React.Fragment>
        {custombutton}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Button/Button.js